var render = function render() {
  var _vm$form, _vm$form2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    attrs: {
      "title": "Fornecedor",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 0;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fornecedor",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    class: {
      hasErrors: _vm.clienteError,
      inputFilled: _vm.clienteFilled
    },
    attrs: {
      "filterable": false,
      "state": _vm.validateClienteState('nome'),
      "options": _vm.fornecedores
    },
    on: {
      "input": _vm.setFornecedor,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do fornecedor ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CPF/CNPJ",
      "label-for": "cnpj_cpf"
    }
  }, [_vm.hasCnpjAlfanumerico(_vm.form.cnpj_cpf) ? _c('b-form-input', {
    key: "".concat(_vm.keyToReRender, "-alfa"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "value": _vm.formatCnpjAlfanumerico(_vm.form.cnpj_cpf)
    }
  }) : _c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##', '##.###.###/####-##'],
      expression: "['###.###.###-##', '##.###.###/####-##']"
    }],
    key: "".concat(_vm.keyToReRender, "-numeric"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf"
    },
    model: {
      value: _vm.form.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cnpj_cpf", $$v);
      },
      expression: "form.cnpj_cpf"
    }
  })], 1)], 1)], 1), _c('b-row', [(_vm$form = _vm.form) !== null && _vm$form !== void 0 && _vm$form.enderecos ? _c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Endereço",
      "label-for": "endereco"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "endereco",
      "name": "endereco",
      "value": _vm.formatEndereco((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : _vm$form2.enderecos[0])
    }
  })], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };